export default "__VITE_ASSET__55b9b005__"